<template>
  <v-text-field
    v-model="offerData.content"
  >
    <v-icon
      slot="append"
      @click="saveContent(offerData)"
    >
      mdi-check
    </v-icon>
  </v-text-field>
</template>

<script>
export default {
   props: {
      offerData: {
         type: Object,
         required: true,
      },
   },
   methods: {
      saveContent (offerData) {
         const form = this.$inertia.form({
            content: offerData.content
         })
         form.patch(this.route('customer.update.offer-data-content', { offerData: offerData.id }), { preserveScroll: true })
      }
   }
}
</script>

<style>
</style>
